import { useGlobal } from "@/app/store/global"
import Logo from "@/shared/assets/images/logo.svg"
import { useMediaQuery } from "@/shared/hooks/use-media-query.ts"
import { useTranslation } from "react-i18next"

export function SidebarHeader() {
  const isLaptop = useMediaQuery("(max-width: 1200px)")
  const isOpened = useGlobal(state => (isLaptop ? false : state.sidebarIsOpened))
  const { t } = useTranslation("common")

  return (
    <div className="sidebar__header">
      <div className="sidebar__header-logo flex items-center">
        <img src={Logo} width={isOpened ? 48 : 30} alt="Yagona Energiya auditi tizimi Logo" className="transition-all" />
        <div className="header-titles transition-all">
          <p className="text-nowrap text-sm">{t("logo_title")}</p>
        </div>
      </div>
    </div>
  )
}
